import { render } from "./BusinessRulesByCustomObjectFromCache.vue?vue&type=template&id=0e0a8dfa"
import script from "./BusinessRulesByCustomObjectFromCache.vue?vue&type=script&lang=js"
export * from "./BusinessRulesByCustomObjectFromCache.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__